import { useScheduleContext } from "./context/useScheduleContext";

export const useIsTemplate = () => {
    const { type } = useScheduleContext();
    return ["template", "profile", "my-profile"].includes(type);
};
